export default __webpack_public_path__ + "50a06562f37b64240802151d16adc37e.svg";